import './SPStatusBox.scss';
import { Box } from '@mui/material';
import TranslateDate from '../../../pages/SellerProfile/TranslateDate';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const SPStatusBox = () => {
  const { compProfile } = useSelector((state: any) => state.sellerProfile);
  const dateValue = compProfile?.registration_date || '';
  const { t, i18n } = useTranslation();
  const date = TranslateDate(dateValue, i18n.language);

  const getStatusField = () => {
    switch (i18n.language) {
      case 'fr':
        return compProfile?.status_fr;
      default:
        return compProfile?.status_en;
    }
  }; 
  const currentStatus = getStatusField();

  const isCurrentStatusBuilding =
    currentStatus === t('sellerProfile.dashboard.status.building');

  return (
    <Box className="spStatusBox">
      <div className="registerDate">
        <h4>
          {t('sellerProfile.dashboard.registered')} {date}
        </h4>
      </div>
      <div className="statusContainer">
        <div className="currentStatusBox">
          <h4 className="currentStatusTitle">
            {t('sellerProfile.dashboard.currentStatus')}
          </h4>

          <p className="currentStatus">
            {currentStatus ===
            t('sellerProfile.dashboard.status.building')
              ? t('sellerProfile.dashboard.status.building')
              : currentStatus ===
                t('sellerProfile.dashboard.status.certified')
              ? t('sellerProfile.dashboard.status.certified')
              : t('sellerProfile.dashboard.status.onboarding')}
          </p>
        </div>
        {currentStatus !==
        t('sellerProfile.dashboard.status.certified') ? (
          <div className="nextStatusBox">
            <h4 className="nextStatusTitle">
              {t('sellerProfile.dashboard.nextStatus')}
            </h4>
            {!isCurrentStatusBuilding && (
              <p className="nextStatus">
                {t('sellerProfile.dashboard.building')}
              </p>
            )}
            <p className="nextStatus">
              {t('sellerProfile.dashboard.certified')}
            </p>
          </div>
        ) : null}
      </div>
    </Box>
  );
};

export default SPStatusBox;
